// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@guestsupply/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
    };
}

type Props = OwnProps;

interface ContainerWidgetStyles {
    container?: InjectableCss;
}

const containerWidgetStyles: ContainerWidgetStyles = {
    container: {
        css: css`
            width: 100%;
            ${({ backgroundColor }: any) => {
                if (backgroundColor) {
                    return css`
                        background: linear-gradient(
                            to bottom,
                            transparent 0,
                            transparent 12px,
                            ${backgroundColor} 12px,
                            ${backgroundColor} 100%
                        );
                        ${xScreen("lte", "sm")} {
                            background: ${backgroundColor};
                        }
                    `;
                }
            }}
        `,
    },
};

const ContainerWidget: React.FC<Props> = ({ fields: { backgroundColor }, id }) => {
    const styles = containerWidgetStyles;
    return (
        <StyledWrapper {...styles.container} {...({ backgroundColor } as any)}>
            <Zone contentId={id} zoneName="Content" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ContainerWidget,
    definition: {
        group: "Xngage Custom" as any,
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
